// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3cot3IPJOycaqRgnSU2Tjv"};